import Router from 'next/router'
import {SUPPORTED_LANGUAGES} from '../constants/languages'

export default class ModelExampleCategory {
  public id?: number
  public name_en?: string
  public name_fr?: string
  public name_de?: string
  public priority?: number

  get name(): string {
    const lang = Router.locale

    switch (lang) {
      case SUPPORTED_LANGUAGES.fr:
        return this.name_fr || ''
      case SUPPORTED_LANGUAGES.de:
        return this.name_de || ''
      case SUPPORTED_LANGUAGES.en:
      default:
        return this.name_en || ''
    }
  }
}
